import React from "react";
import "./styles/tailwind.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SignIn from "./Components/Auth/SignIn";
import SignUp from "./Components/Auth/SignUp";
import ForgotPasswd from "./Components/Auth/ForgotPasswd";
import UsernameSetup from "./Components/Auth/UsernameSetup";
import ProtectedRoute from "./Components/Auth/ProtectedRoute";
import TermsOfService from "./Pages/TermsOfService";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Main from "./Components/Dashboard/Main";
import Main2 from "./Components/Account/Main2";
import "./styles/tailwind.css";
import Technology from "./Components/Quiz/Technology";
import QuizCreationChoice from "./Components/MakeQuiz/QuizCreationChoice";
import Leaderboard from "./Components/Leaderboard/Leaderborad";
import LeaderboardFullscreen from "./Components/Leaderboard/LeaderboardFullscreen";
import Notifications from "./Components/Notifications/Notifications";
import QuizQuestions from "./Components/Quiz/QuizQuestions";
import ReviewQuiz from "./Components/Quiz/ReviewQuiz";
import TakeQuiz from "./Components/Quiz/TakeQuiz";
import QuizReview from "./Components/Quiz/QuizReview";
import QuizOverview from "./Components/Quiz/QuizOverview";
import Medicine from "./Components/Quiz/Medicine";
import Agriculture from "./Components/Quiz/Agriculture";
import MedicineQuestions from "./Components/Quiz/MedicineQuestions";
import ReviewQuizMedicine from "./Components/Quiz/ReviewQuizMedicine";
import CategoryDetail from "./Components/Quiz/CategoryDetail";
import AllCategories from "./Components/Dashboard/AllCategories";
import AllQuizzesInCategory from "./Components/Quiz/AllQuizzesInCategory";
import { NotificationProvider } from "./contexts/NotificationContext";
import { NavigationProvider } from "./contexts/NavigationContext";
import ToastNotification from "./Components/Common/ToastNotification";

function App() {
  return (
    <NotificationProvider>
      <NavigationProvider>
        <div className="App">
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <ToastNotification />
          <Routes>
          {/* Public Routes - No Authentication Required */}
          <Route path="/" element={<SignIn />} />
          <Route path="/login" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPasswd />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />

          {/* Semi-Protected Route - Requires OAuth but no username yet */}
          <Route path="/username-setup" element={<UsernameSetup />} />

          {/* Protected Routes - Authentication Required */}
          <Route
            path="/main"
            element={
              <ProtectedRoute>
                <Main />
              </ProtectedRoute>
            }
          />

          {/* Navbar Pages */}
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <Main2 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/makequiz"
            element={
              <ProtectedRoute>
                <QuizCreationChoice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notification"
            element={
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leaderboard"
            element={
              <ProtectedRoute>
                <LeaderboardFullscreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leaderboard/sidebar"
            element={
              <ProtectedRoute>
                <Leaderboard />
              </ProtectedRoute>
            }
          />

          {/* Quiz Category Routes */}
          <Route
            path="/categories"
            element={
              <ProtectedRoute>
                <AllCategories />
              </ProtectedRoute>
            }
          />
          <Route
            path="/category/:categorySlug"
            element={
              <ProtectedRoute>
                <CategoryDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/category/:categorySlug/all-quizzes"
            element={
              <ProtectedRoute>
                <AllQuizzesInCategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/technology"
            element={
              <ProtectedRoute>
                <Technology />
              </ProtectedRoute>
            }
          />
          <Route
            path="/medicine"
            element={
              <ProtectedRoute>
                <Medicine />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agriculture"
            element={
              <ProtectedRoute>
                <Agriculture />
              </ProtectedRoute>
            }
          />

          {/* Quiz Taking & Review Routes (New System) */}
          <Route
            path="/quiz/:quizSlug/overview"
            element={
              <ProtectedRoute>
                <QuizOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz/:quizSlug/take"
            element={
              <ProtectedRoute>
                <TakeQuiz />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz/:quizSlug/review"
            element={
              <ProtectedRoute>
                <QuizReview />
              </ProtectedRoute>
            }
          />

          {/* Legacy Quiz Questions Routes (Keep for backward compatibility) */}
          <Route
            path="/quiz-questions"
            element={
              <ProtectedRoute>
                <QuizQuestions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/medicinequestions"
            element={
              <ProtectedRoute>
                <MedicineQuestions />
              </ProtectedRoute>
            }
          />

          {/* Legacy Review Routes (Keep for backward compatibility) */}
          <Route
            path="/quiz-review"
            element={
              <ProtectedRoute>
                <ReviewQuiz />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz-review-medicine"
            element={
              <ProtectedRoute>
                <ReviewQuizMedicine />
              </ProtectedRoute>
            }
          />
        </Routes>
        </BrowserRouter>
      </div>
      </NavigationProvider>
    </NotificationProvider>
  );
}

export default App;
